<script setup lang="ts">
defineProps({
  color: {
    type: String,
    default: 'aqua', // navy, aqua(default)
  },
  title: {
    type: String,
  },
  description: {
    type: String,
  },
  image: {
    type: String,
    default: '',
  },
  imageWidth: {
    type: [Number, String],
    default: null,
  },
  imageHeight: {
    type: [Number, String],
    default: null,
  },
  imageAltText: {
    type: String,
  },
})
</script>

<template>
  <div
    class="article-hero"
    :class="{ 'article-hero--navy dark-bg': color === 'navy' }"
  >
    <div class="container-fluid">
      <div class="article-hero__body prose">
        <slot />
        <h1
          v-if="title"
          class="last:mb-0"
        >
          {{ title }}
        </h1>
        <p
          v-if="description"
          class="last:mb-0"
        >
          {{ description }}
        </p>
      </div>
    </div>
  </div>
  <div
    v-if="image && image !== 'false'"
    class="article-hero__media container-fluid"
  >
    <div class="article-hero__media-col">
      <NuxtImg
        provider="fastlyAprimo"
        :src="`${image}`"
        class="article-hero__image rounded-xl relative"
        :alt="imageAltText ?? ''"
        :width="imageWidth ?? 954"
        fit="bounds"
        sizes="(max-width: 768px) 100vw, 954px"
      />
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/blocks/article-hero-block.scss';
@use '@/assets/css/blocks/hero-block.scss';
</style>
